module.exports = __webpack_public_path__ + "static/media/sensa-white.1cbb5ad7.svg";